import { useState, useEffect } from 'react';
import { getOrgId } from '../services/api';

/**
 * Resolves current organisation id once on mount (same semantics as getOrgId()).
 */
export function useResolvedOrgId() {
  const [orgId, setOrgId] = useState<any>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getOrgId()
      .then((id) => {
        if (!cancelled) setOrgId(id);
      })
      .catch(() => {
        if (!cancelled) setOrgId(null);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { orgId, ready };
}
